import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const RowWithLabel = ({ label, required, children, spaced }) => (
  <>
    <div className={styles.rowLabel}>
      {label}
      {required && (<span className={styles.requiredStar}> *</span>)}
    </div>
    <div className={`${styles.rowContent} ${spaced && styles.rowContentSpaced}`}>
      {children}
    </div>
  </>
);

RowWithLabel.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  spaced: PropTypes.bool,
  required: PropTypes.bool,
};

RowWithLabel.defaultProps = {
  spaced: false,
  required: false,
};

export default RowWithLabel;
